// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"Breadcrumb_breadcrumbContainer__3RJVg","home":"Breadcrumb_home__38XOx","separator":"Breadcrumb_separator__1bgUa"};